import React from "react";
import { AvatarProps } from "react-native-gifted-chat";
import { FormattedChatMessage } from "../../app/types";
import AttendeeAvatar from "../attendeeList/AttendeeAvatar";

const GiftedChatAvatar = (props: AvatarProps<FormattedChatMessage>) => {
  const { currentMessage } = props;
  if (!currentMessage) {
    return null;
  }
  return (
    <AttendeeAvatar
      name={currentMessage.user.name ?? ""}
      url={currentMessage.user.avatar as string | undefined}
    />
  );
};
export default GiftedChatAvatar;
